import config from '../config.js'
import { ref} from "vue"
export function fetchJsonObject() {
    let GlassesList = ref([])
    let translation = ref({})
    let brands = ref({})
    let lastResponse = ref({
        list: config.jsonUrl
    })
    fetchGlasses()

    function fetchGlasses() {
        fetch(lastResponse.value.list)
            .then(response => response.json())
            .then(data => {
                GlassesList.value.push(...data.itemlist)
                translation.value = data.translation
                brands.value = data.brands
            })

    }
    return {
        GlassesList,
        fetchGlasses,
        translation,
        brands
    }
}